import React, { useId } from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
}

export const Input: React.FC<InputProps> = ({ label, className = '', id, ...props }) => {
  const generatedId = useId();
  const inputId = id || generatedId;
  return (
    <div className="flex flex-col gap-1 mb-4">
      {label && <label htmlFor={inputId} className="text-sm font-semibold text-primary font-sans">{label}</label>}
      <input
        id={inputId}
        className={`border border-primary/20 rounded p-2 focus:ring-2 focus:ring-accent focus:border-accent focus:outline-none bg-bg-card text-primary placeholder-primary/40 ${className}`}
        {...props}
      />
    </div>
  );
};
